import { Breadcrumbs } from '@digdir/designsystemet-react';

export const BackLink = ({ parentLink }: { parentLink: string }) => {
    return (
        parentLink && (
            <Breadcrumbs>
                <Breadcrumbs.Link href={parentLink}>Tilbake</Breadcrumbs.Link>
            </Breadcrumbs>
        )
    );
};
